import { cart, pubsub } from '@services';

class CartSummary extends HTMLElement {
  unsubscribers = [];
  buttons = this.querySelectorAll('.button');

  static {
    cart.sections.push('fetch-cart-summary');
  }

  connectedCallback() {
    ['cart:add', 'cart:update', 'cart:change'].forEach(event =>
      this.unsubscribers.push(
        pubsub.subscribe(event, ({ sections }) => this.renderSection(sections)),
      ),
    );
    this.unsubscribers.push(pubsub.subscribe('cart:fetching', () => this.handleLoading(true)));
    ['cart:fetched', 'cart:error'].forEach(event =>
      this.unsubscribers.push(pubsub.subscribe(event, () => this.handleLoading(false))),
    );
  }

  disconnectedCallback() {
    this.unsubscribers.forEach(unsubscribe => unsubscribe());
  }

  renderSection(sections) {
    const html = new DOMParser().parseFromString(sections['fetch-cart-summary'], 'text/html');
    const target = html.querySelector('cart-summary');
    this.replaceWith(target);
  }

  handleLoading(loading) {
    this.buttons.forEach((button) => {
      button.classList.toggle('loading', loading);
    });
  }
}

customElements.define('cart-summary', CartSummary);
